
export const CurrencyAlignment = {
    RIGHT: 'Derecha',
    LEFT: 'Izquierda',
  }
  